module.exports = function() {
	const _ctrl = $('.js-sortbyyear a');
	const target = $('.js-status-finished .js-finished-item');
	const placeholder = $('.js-year-placeholder');
	const D = new Date();
	const Y = D.getFullYear();
	const status_pickup = $('.js-status-pickup');
	const status_held = $('.js-status-be_held');
	const status_finished = $('.js-status-finished');
	let target_y;

	const _sort = (target,year) => {
		target.hide();
		target.each(function(){
			if($(this).data('year') == year){
				$(this).show();
			}
		});
	}

	_ctrl.on('click',function(){
		target_y = $(this).attr('href');
		placeholder.text(target_y+ '年度');

		if(target_y == Y){
			status_held.show();
			status_pickup.show();
		}else{
			status_held.hide();
			status_pickup.hide();
		}

		_sort(target,target_y);

		return false;
	});

	$(document).ready(function(){
		target_y = placeholder.data('year');
		_sort(target,target_y)
	});
}



// WEBPACK FOOTER //
// ./dev/js/scripts/year_sort.js